<template>
    <div class="flex mt-4 flex-wrap md:flex-nowrap pb-10 md:pb-0">
        <form-values
            class="xl:w-2/5 lg:w-2/5 md:w-80 w-full pb-5"
            :options-inputs="{
                amount: {
                    readonly: true,
                },
                description: {
                    readonly: true,
                    class: 'opacity-60'
                },
                receiver_code: {
                    readonly: true,
                    class: 'opacity-60'
                }
            }"
            :title="'Preencha os campos'"
            :form="form"
            @go-back="$emit('go-back')"
        />

        <form-summary
            class="flex-1 md:mb-6 lg:mb-0 mb-0"
            :form="form"
            :favored="favoredFormatted"
            @input="form[$event.type] = $event.value"
            @submit="transferPix"
        />
    </div>
</template>

<script>
import moment from 'moment'
import JetInput from "../../../Jetstream/Input.vue";
import JetInputError from "../../../Jetstream/InputError.vue";
import JetDecimal from "../../../Jetstream/Decimal.vue";
import JetLabel from "../../../Jetstream/Label.vue";
import JetTextarea from "../../../Jetstream/Textarea.vue";
import JetDatePicker from "../../../Jetstream/DatePicker.vue";
import Favored from '../components/Favored.vue';
import FormValues from '../components/FormValues.vue';
import FormSummary from "../components/FormSummary.vue";
import { generateRandomColor, getNameInitials } from '../utils/utils';

export default {
    name: 'FormValueDetails',
    props: {
        favored: { type: Object, required: true}
    },
    data(){
        return {
            datePix: new Date(),
            form: this.$inertia.form({
                _method: 'POST',
                pixCode: null,
                amount: new Intl.NumberFormat('pt-Br', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(parseFloat(this.favored.valor)),
                contact: {
                    name: this.favored.nome,
                    federal_document: this.favored.documentoFederal
                },
                transfer_type: {
                    name: 'PIX'
                },
                pix_type: null,
                qrcode_type: this.favored.tpQRCode,
                qrcode_read_type: this.favored.codigoLeituraQRCode,
                selected_account: {
                    agency: null,
                    bank: {
                        id: null,
                        name: null
                    },
                    number: null,
                    key: this.favored.chave,
                    type: 'PIX'
                },
                federal_document: null,
                goal: {
                    id: 99999,
                    name: "Outros"
                },
                google_code: null,
                receiver_code: this.favored.idConciliacaoRecebedor,
                description: this.favored.informacoesAdicionais || null,
            }, {
                resetOnSuccess: false,
            }),
        }
    },
    computed: {
        favoredFormatted(){
            return {
                ...this.favored,
                name: this.favored.nomeCorrentista,
                key: this.favored.chave,
                bgItemList: generateRandomColor(),
                initialsName: getNameInitials(this.favored.nomeCorrentista),
                bank: {
                    number: this.favored.banco.numero,
                    description: this.favored.banco.descricao
                },
                account: {
                    account: this.favored.conta.conta,
                    agency: this.favored.conta.agencia
                }
            }
        },
        formatDate(){
            const formatDatePicker = 'dd/MM/yyyy'
            const format = 'DD/MM/YYYY'
            return moment(this.datePix).format(format) === moment().format(format)
                ? formatDatePicker + " \(Hoje\)"
                : formatDatePicker
        },
    },
    methods: {
        transferPix(){
            if(this.form.processing) return
            const amount = this.form.amount.replace(".", "").replace(',', '.')
            if (parseFloat(amount) === 0) {
                this.callToast('Informe o valor da operação.', 'error');
                return;
            } else if (!this.form.google_code){
                this.callToast('Informe o código de autorização.', 'error');
                return;
            }

            this.form.post(`/transfer`, {
                preserveScroll: true,
                onError: (e) => {
                    this.form.processing = false;
                    this.$forceUpdate();
                },
            });
        },
        callToast(msg, type, temp = 5000) {
            this.$toast.open({
                message: msg,
                type: type,
                duration: temp,
                position: 'top-right'
            });
        }
    },
    components: {
        JetInput,
        JetDecimal,
        JetLabel,
        JetTextarea,
        JetDatePicker,
        JetInputError,
        FormValues,
        Favored,
        FormSummary
    }
}
</script>
